import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, Input, ViewChild, NgModule, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, NavigationExtras } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { environment } from '../../../environments/environment.prod';

import { CustomNavigation, TABPANEL } from '../../class/appinterface';
import { ComponentService } from '../../services/component.service';

class _tasto {
  id: any;
  text?: string;
  icon?: string;
  disabled?: boolean;
  image?: string;
  separator?: boolean;
  visible?: boolean | Function;
  hint?: string;
  name?: string
  location?: 'before' | 'center' | 'after';
  widget: string = 'button'
}


@Component({
  selector: 'app-caption',
  templateUrl: './caption.component.html',
  styleUrls: ['./caption.component.scss']
})
export class CaptionComponent implements OnInit {


  /** Titolo da mostrare */
  @Input() caption: string = '';
  @Input() breadcrumbCaption?: string;
  @Input() breadcrumbGroup?: any;
  @Input() breadcrumbNavigation?: any;
  @Input() isPopUp: boolean = false
  @Input() showToolBarButton: boolean = true

  /** Specifica che si tratta solo del footer e ne altera lo stile */
  @Input() isFooter: boolean = false;
  @Input() showCaptionFooter: boolean = true;


  /**Bottoni Vari i nomi sono esplicativi nel capire a che servono **/
  @Input() toolbarButtonsBottomRight: any = [];
  @Input() toolbarButtonsBottomLeft: any = [];

  /***Se specificato sostituisce i bottoni assegnatri a toolbarButtonsBottomLeft toolbarButtonsBottomRight***/
  @Input() buttonCustomsBottomToolbar: any = []
  /** Specifica vi deve essere solo il Titolo su sfondo trasparente  */
  @Input() onlyTitle: boolean = false;



  /** Di default si può chiudere (true) */
  @Input() isClosable: boolean = true;
  @Input() isSave: boolean = false;

  @Input() isButtonActived: boolean = false;
  @Input() customNavigation: Array<CustomNavigation> = [];
  @Input() showBreadcrumb: boolean = false;
  @Input() currentTemplate;

  /** URL HELPER */
  @Input() help: string = "";
  @Input() idHelper: number = 0;


  @Output() emettiHelperClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() emettiChiusura: EventEmitter<any> = new EventEmitter<any>();
  @Output() emettiNavCustomClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() emettiButtonToolbarClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() emettiBreadCrumbClick: EventEmitter<any> = new EventEmitter<any>();

  dsTastiBottom: _tasto[] = [
    {
      icon: 'close',
      id: 1,
      text: 'chiudi',
      visible: true,
      widget: "dxButton"
    },
    {
      icon: 'save',
      id: 2,
      text: 'Salva',
      visible: true,
      widget: "dxButton",
    }
  ];

  annullaButtonOptions = {
    icon: 'close',
    text: 'Chiudi',
    visible: true,
    onClick: () => { this.onClickCrocetta('close') },
    stylingMode: 'text',
    locateInMenu: 'auto',
    //location: "after",
    //widget: "dxButton",   
    //locateInMenu: "never",
  };

  salvaButtonOptions = {
    icon: 'save',
    text: 'Salva',
    visible: true,
    onClick: () => { this.onClickCrocetta('save') },
    stylingMode: 'text',
    locateInMenu: 'auto',
    //location: "after",
    //widget: "dxButton",   
    //locateInMenu: "never",
  };


  serviceAttuale: string;

  navigation: any[] = [];
  componentNavigation: any[];
  currentIndexNav: number
  params;



  tabs: TABPANEL[] = []
  componentName: string;
  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private componentService: ComponentService,
    private loader: NgxSpinnerService

  ) {


  }
  chiudiPopupEditing() {
    const cUrl = this.router.url.split('?')[0];
    if (!cUrl || cUrl == '') {
      this.emettiChiusura.emit('close')
      return;
    }
    const navigationParams = {
      id: this.params.currentTabId,
      masterKey: 'id',
      currentTabId: this.params.currentTabId,
      currentTabName: this.params.currentTabName,
      componentName: this.params.currentTabName,
      close: true
    }
    this.router.navigate(['/'], {
      skipLocationChange: false,
      replaceUrl: true
    }).then(() => {

      // Forzo a naviagare verso questa url per aggiornare i dati. 
      //sono costretto a ricaricare in maniera forzata il componente in attesa di idee
      let navigationExtras: NavigationExtras = {
        queryParams: navigationParams,
        skipLocationChange: false,
        replaceUrl: true
      };
      this.router.navigate([cUrl], navigationExtras);
    });



    // alert("Che faccio");
  }
  ngOnInit() {

    //alert(this.isPopUp);
    console.log('stampo i votttonfid', this.buttonCustomsBottomToolbar)
    if (this.showBreadcrumb) {
      this.activateRoute.queryParams.subscribe(params => {
        this.params = params;



        if (params.service) {


          this.serviceAttuale = params.service;


        }


      })



      this.navigation = this.breadcrumbNavigation



      if (this.navigation)
        this.currentIndexNav = this.navigation.length - 1
    } else {
      this.activateRoute.queryParams.subscribe(params => {
        this.params = params
        if (this.help === '-') {
          this.help = ''
          return
        }

        if (this.params['helpDoc']) {
          this.help = this.params['helpDoc']
        }

      })
    }


    if (this.isSave) {
      this.toolbarButtonsBottomRight.push(15)
    }
    if (this.isClosable) {
      this.toolbarButtonsBottomRight.push(0)
    }

    //console.log('buttonCustomsBottomToolbar-->',this.buttonCustomsBottomToolbar)
  }
  hideShowToolbarMenu(ev) {

    this.emettiChiusura.emit('closeToolbar')
  }

  parseTitle(title) {
    //console.log(title)
    if (typeof title != 'undefined') {
      if (title.includes('$')) {
        let splitted = title.split('$');
        let htmlTitle = ''
        let caption = ''
        splitted.forEach((split, i) => {
          if (i == 0) {
            htmlTitle += split
          } else {
            htmlTitle += ' <span class="fw-bolder">' + split + '</span>';
          }
          //htmlTitle = split + ' <span class="fw-bolder"><i> - ' + splitted[1] + '</i></span>';
        })

        let newHtml = htmlTitle.replace("Modifica", "");
        newHtml = newHtml.replace("Inserisci", "");
        newHtml = htmlTitle.replace("Elenco", "");

        //
        return newHtml;// htmlTitle+"ecco";
      } else {
        return title
      }
    }
  }

  onClickCrocetta(ev) {

    let index = this.currentIndexNav - 1;


    if (index > -1) {
      this.onBreadCrumbClick(ev, this.navigation[index])
    } else {
      this.emettiChiusura.emit(ev);
    }

  }

  showDropdownMenu(ev, id) {


    let elememt = document.getElementById(id);

    if (elememt != null) {
      if (!elememt.classList.contains('show')) {
        elememt.classList.add('show')
      }
    }



  }
  hideDropdownMenu(ev, id) {
    let elememt = document.getElementById(id);
    if (elememt != null) {
      elememt.classList.remove('show')
    }
  }

  onBreadCrumbClick(event, item, i = '') {


    //console.warn('itemClicked:',item);
    /*
    this.emettiBreadCrumbClick.emit(item);

    return;
    */



    setTimeout(() => {
      this.router.navigate(['/'], {
        skipLocationChange: true,
        replaceUrl: true
      }).then(() => {
        // Forzo a naviagare verso questa url per aggiornare i dati. 
        //è un pezzoto ma NicaAnagrafica non si aggiorna,
        //sono costretto a ricaricare in maniera forzata il componente in attesa di idee

        this.serviceAttuale = item.params.service;

        let navigationExtras: NavigationExtras = {
          queryParams: item['params'],
          skipLocationChange: true,
          replaceUrl: true
        };



        this.router.navigate([item['cRouter']], navigationExtras);
        if (typeof item.idGroup == 'undefined') {
          //this.componentService.removeLastItemComponentNavigation(this.params.currentTabId)
        }

        this.loader.hide();
      });
    }, 200);


    return

  }

  onBreadCrumbRemoveClick(event, item, i) {

    const prevItem = this.navigation[i - 1];

    this.navigation.splice(i, 1);
    this.onBreadCrumbClick(event, prevItem);
    this.componentService.removeItemComponentNavigation(item.id, item.params.currentTabId)
    this.componentService.removeOptionalParameter(item.params.currentTabId);
  }

  emettiHelpClick(evt: any) {
    // if(this.help>""){
    var w = 1064;
    var h = 800;
    const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);

    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);

    this.loader.show();

    setTimeout(() => {
      let data = {

        url: environment.BASE_URL_HELP + this.help,
        enableShow: true
      }

      this.componentService.enableHelpNDoc(data);
      this.loader.hide();
    }, 1000);



  }
  navigationClick(ev) {

    this.emettiNavCustomClick.emit(ev)
  }
  backButton(ev) {

    let index = this.currentIndexNav - 1;

    if (index > -1) {
      this.onBreadCrumbClick(ev, this.navigation[index])
    }


  }

  emettiToobarButton(ev) {
    console.log('emettiToobarButton', ev)
    let index = this.currentIndexNav - 1;

    if (index > -1) {
      this.onBreadCrumbClick(ev, this.navigation[index])
      return
    }

    switch (ev) {
      case 0:
        this.emettiChiusura.emit('close');
        break;
      case 16:
        this.emettiChiusura.emit('ritorna');
        break;
      case 29:
        this.emettiChiusura.emit('close');
        this.componentService.eventoToolbarEmit('inviaContratto')
        break;
      case 30:
        this.emettiChiusura.emit('close');
        this.componentService.eventoToolbarEmit('inviaCensimento')
        break;
      default:
        this.emettiChiusura.emit(ev);
        break;
    }

    // this.emettiButtonToolbarClick.emit(ev)
  }

}


